import { useLiveQuery } from "dexie-react-hooks";
import { Link } from "react-router-dom";
import { getDb } from "../../db/dexie";

/** App-wide: how many records have changes the server refused. Hidden at 0. */
export function useFailedRecordCount(): number {
  return (
    useLiveQuery(async () => {
      const rows = await getDb().deadLetter.toArray();
      return new Set(rows.map((r) => `${r.entity}:${r.id}`)).size;
    }, []) ?? 0
  );
}

export function SyncIssuesBadge() {
  const n = useFailedRecordCount();
  if (n === 0) return null;
  const label = `${n} ${n === 1 ? "change" : "changes"} didn't sync. Review`;
  return (
    <Link to="/settings/sync" className="sync-issues" aria-label={label} title={label} data-testid="sync-issues">
      <span aria-hidden="true">⚠</span>
      <span>{n}</span>
      <span className="sync-issues-words">not synced</span>
    </Link>
  );
}
